import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import SelectionHeader from '@src/app/voice/ongoing-call/SelectionHeader'
import { useCallContext } from '@src/app/voice/ongoing-call/context/useCallContext'
import useKeyboardShortcuts from '@src/lib/hooks/useKeyboardShortcuts'

import CallTransferSelector from './CallTransferSelector'
import CallTransferStatus from './CallTransferStatus'

interface CallTransferProps {
  onClose: () => void
}

const CallTransfer = function ({ onClose }: CallTransferProps) {
  const controller = useCallContext().transferController

  const handleBack = () => {
    controller.handleBack()
    onClose()
  }

  useKeyboardShortcuts({
    name: 'CallTransfer',
    node: document,
    filter: (_, e) => !e.defaultPrevented,
    handler: (shortcut, event) => {
      if (shortcut === 'Escape') {
        handleBack()
        event.preventDefault()
      }
    },
    dep: [controller],
  })

  useEffect(() => {
    if (
      controller.transferState === 'in-progress' ||
      controller.transferState === 'success'
    ) {
      // 'in-progress' and 'success' states are currently descoped
      // https://linear.app/openphone/issue/VOICE-8083/product-decision-needed-to-refine-the-ux-when-a-warm-transfer-is
      onClose()
    }
  }, [controller.transferState, onClose])

  useEffect(() => {
    return () => {
      controller.handleBack()
    }
  }, [controller])

  return (
    <>
      {controller.transferMode === 'selector' ? (
        <>
          <SelectionHeader
            title="Transfer call"
            description="When transferring a call, you will remain on the line until you choose to leave."
            handleBack={handleBack}
          />
          <CallTransferSelector />
        </>
      ) : (
        <>
          <SelectionHeader
            title=""
            description=""
            handleBack={controller.transferState === 'success' ? handleBack : undefined}
          />
          <CallTransferStatus />
        </>
      )}
    </>
  )
}

export default observer(CallTransfer)
